module.exports = __webpack_public_path__ + "static/don3-6aaba2d5f11541221b9875eff0e2f8c6.jpg";